// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_FechamentoDiarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for GET /caixa/fechamento-diario
 */
import type { Caixa_ExtratoItemRow } from './Caixa_ExtratoItemRow'
import type { Caixa_FechamentoConferenciaRow } from './Caixa_FechamentoConferenciaRow'
import type { Caixa_FechamentoDespesaRow } from './Caixa_FechamentoDespesaRow'
import type { Caixa_FechamentoResumoRow } from './Caixa_FechamentoResumoRow'
import type { Caixa_FechamentoSangriaRow } from './Caixa_FechamentoSangriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_FechamentoDiarioResponseDados {
data: string
franquia_id: number
resumo: Caixa_FechamentoResumoRow
conferencia: Caixa_FechamentoConferenciaRow
recebimentos: Caixa_ExtratoItemRow[]
despesas: Caixa_FechamentoDespesaRow[]
sangrias: Caixa_FechamentoSangriaRow[]
}

export type Caixa_FechamentoDiarioResponse = ApiResponse<Caixa_FechamentoDiarioResponseDados>;

registerResponseContract('Caixa_FechamentoDiarioResponse', {
  data:         { type: 'string',  required: true },
  franquia_id:  { type: 'number',  required: true },
  resumo: {
    type: 'object',
    required: true,
    fields: {
      c1_entradas_manuais:      { type: 'number',  required: true },
      c2_recebimentos_dinheiro: { type: 'number',  required: true },
      d1_saidas_dinheiro:       { type: 'number',  required: true },
      saldo:                    { type: 'number',  required: true },
    },
  },
  conferencia: {
    type: 'object',
    required: true,
    fields: {
      dinheiro_esperado:    { type: 'number',  required: true },
      dinheiro_conferido:   { type: 'number',  required: true },
      eletronico_esperado:  { type: 'number',  required: true },
      eletronico_conferido: { type: 'number',  required: true },
      total_esperado:       { type: 'number',  required: true },
      total_conferido:      { type: 'number',  required: true },
    },
  },
  recebimentos: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: false },
      caixa_abertura_id: { type: 'number',  required: false },
      tipo:              { type: 'string',  required: false },
      forma_pagamento:   { type: 'string',  required: false },
      cofre_id:          { type: 'number',  required: false },
      valor:             { type: 'string',  required: false },
      entrada_saida:     { type: 'string',  required: false },
      saldo_antes:       { type: 'string',  required: false },
      saldo_depois:      { type: 'string',  required: false },
      origem:            { type: 'string',  required: false },
      origem_id:         { type: 'number',  required: false },
      observacao:        { type: 'string',  required: false },
      conferido:         { type: 'number',  required: false },
      operador_id:       { type: 'number',  required: false },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
      deleted_at:        { type: 'string',  required: false },
    },
  },
  despesas: {
    type: 'array',
    required: true,
    items: {
      id:         { type: 'number',  required: true },
      descricao:  { type: 'string',  required: true },
      valor:      { type: 'number',  required: true },
      created_at: { type: 'string',  required: false },
    },
  },
  sangrias: {
    type: 'array',
    required: true,
    items: {
      id:         { type: 'number',  required: true },
      valor:      { type: 'number',  required: true },
      cofre_nome: { type: 'string',  required: true },
      observacao: { type: 'string',  required: true },
      created_at: { type: 'string',  required: false },
    },
  },
})
